import { useLocation, useNavigate } from 'react-router-dom';
import { Home, BookOpen, BarChart3, Settings } from 'lucide-react';
import { useTelegramHaptic } from '@/hooks/telegram';

export default function Navigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const haptic = useTelegramHaptic();

  const navItems = [
    { path: '/', icon: Home, label: 'Главная' },
    { path: '/catalog', icon: BookOpen, label: 'Каталог' },
    { path: '/stats', icon: BarChart3, label: 'Статистика' },
    { path: '/settings', icon: Settings, label: 'Настройки' },
  ];

  const handleNavClick = (path: string) => {
    haptic('light');
    navigate(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 glass-nav safe-area-bottom">
      <div className="flex items-center justify-around py-2">
        {navItems.map(({ path, icon: Icon, label }) => {
          const isActive = path === '/'
            ? location.pathname === '/'
            : location.pathname.startsWith(path) || (path === '/catalog' && location.pathname.startsWith('/species'));

          return (
            <button
              key={path}
              onClick={() => handleNavClick(path)}
              className={`flex flex-col items-center py-2 px-2 rounded-xl transition-all duration-200 min-w-0 flex-1 ${
                isActive
                  ? 'nav-active-pill text-plant-green-500'
                  : 'text-tg-hint active:bg-white/5'
              }`}
            >
              <Icon
                className={`w-6 h-6 transition-all duration-200 ${
                  isActive ? 'stroke-[2.5] drop-shadow-[0_0_6px_rgba(34,197,94,0.4)]' : ''
                }`}
              />
              <span className="text-xs mt-1 font-medium truncate max-w-full">{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
